/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import toast from '../../services/toast';
export default {
  name: 'organizations-details',
  components: {},
  props: [],
  data () {
    return {
      orgDetailsById:{},
      nextStep:'',
      orgDetailsByIdUsers:[],
      loadmoreData: {},
      userLoading: false,
      addUserStatus:Boolean,
      DeleteId:'',
      checkDataTaskModal:false,
      checkOrgDeleteModal:false,
      OrgDeleteId:''
    }
  },
  computed: {
  ...mapGetters([
    'OrgDetailByIdGetters'
  ]),
  getOrgDetailsByIdDetailsFun(){
    return this.orgDetailsById = this.$store.getters.OrgDetailByIdGetters.data
  },
  SetIntialStatus() {
    if (this.orgDetailsById != undefined) {
      this.nextStep = this.orgDetailsById.next
      this.addUserStatus = this.orgDetailsById.is_active
      this.orgDetailsByIdUsers = this.orgDetailsById.users
    }
  }
  },
  mounted () {
    this.getOrgDetailsByIdDetailsFun
    this.SetIntialStatus
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('getOrgDetailsByIdFun',{id:this.$route.params.orgId}).then((res) => {
        this.orgDetailsById = this.$store.getters.OrgDetailByIdGetters.data
      }).catch((err) => {
      })
    },
  showRemovedModalFun(id){
    $("body").addClass("task_modal_actv");
    this.checkDataTaskModal = true
    this.DeleteId = id
  },
  removeModalItemConfirmFun(){
    this.$store.dispatch('removeOrgUserFun', {
      id: this.DeleteId,
    })
    .then((res) => {
      if (res.status == '200') {      
        toast.success(res.data.msg); 
        $("body").removeClass("task_modal_actv");
        this.getRemoveListAgain()
        this.checkDataTaskModal = false
        this.DeleteId = ''
      }
    }).catch((err) => {
      toast.error(err.data.user_msg);  
    })
  return;
  },
  closeRemoveItemModalFun(){
    $("body").removeClass("task_modal_actv");
    this.checkDataTaskModal = false
    this.DeleteId = ''
  },
  
  showRemovedOrgModalFun(id){
    $("body").addClass("task_modal_actv");
    this.checkOrgDeleteModal = true
    this.OrgDeleteId = id
  },
  removeModalOrgItemConfirmFun(){
    this.$store.dispatch('removeAcOrgFun', {
      id: this.OrgDeleteId,
    })
    .then((res) => {
      if (res.status == '200') {      
        toast.success(res.data.msg); 
        $("body").removeClass("task_modal_actv");
        this.checkOrgDeleteModal = false
        this.$router.push('/su/organization/');
        this.OrgDeleteId = ''
      }
    }).catch((err) => {
      toast.error(err.data.user_msg);  
    })
  return;
  },
  closeRemoveUserItemModalFun(){
    $("body").removeClass("task_modal_actv");
    this.checkOrgDeleteModal = false
    this.OrgDeleteId = ''
  },
  },
  watch:{
    getOrgDetailsByIdDetailsFun(){
      return this.orgDetailsById = this.$store.getters.OrgDetailByIdGetters.data
    },
    SetIntialStatus() {
      if (this.orgDetailsById != undefined) {
        this.nextStep = this.orgDetailsById.next
        this.addUserStatus = this.orgDetailsById.is_active
        this.orgDetailsByIdUsers = this.orgDetailsById.users
      }
    }
  }
}


